import firestore from "../../firebase/firestore";
export const getPartner = (id) => {
  return firestore.collection("partners").doc(id).get();
};
